// @core/api/endpoints/team/delete_team.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Delete team
 * Permanently deletes a team and removes all member associations. Only the team owner can perform this operation.
 */
export async function DeleteTeam(
  team_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
